import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import * as React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import { MapBalloon } from '../../../components/MapBalloon';
import { TInfrastructurePin } from '../../../types/map';
import { INFRASTRUCTURE_MAIN } from '../MapContainer';

interface IUseGeoObjectBalloonParams {
  infrastructureItemsRef: React.MutableRefObject<Map<string, TInfrastructurePin>>;
}

export const useGeoObjectBalloon = ({ infrastructureItemsRef }: IUseGeoObjectBalloonParams) => {
  const handleBalloonHtmlFirstFetch = React.useCallback(
    async (geoObject: IGeoObject): Promise<string> => {
      const {
        name: type,
        options: { id },
      } = geoObject;

      if (type === INFRASTRUCTURE_MAIN) {
        // Клик по основному объекту - баббл не нужен
        return Promise.resolve('');
      }

      const item = infrastructureItemsRef.current.get(id);

      if (!item) {
        return Promise.reject(new Error('Не верный тип пина!'));
      }

      const balloonProps = {
        description: '',
        routeButtonId: `route-button-${item.id}`,
        title: item.title,
        type,
      };

      const markup = renderToStaticMarkup(<MapBalloon {...balloonProps} />);

      return Promise.resolve(markup);
    },
    [infrastructureItemsRef],
  );

  return { onBalloonHtmlFirstFetch: handleBalloonHtmlFirstFetch };
};
